import { MilestoneMap1 } from '../../types';

/**
 * Generates a URL for a milestone map's tree view
 * @param targetMapUuid - The UUID of the target milestone map
 * @param allMaps - Array of all milestone maps available
 * @returns URL string in format /:ownerUserName/maps/:shortMapId?view=treeview or null if map not found
 */
export function getMapUrl(targetMapUuid: string, allMaps: MilestoneMap1[]): string | null {
  const targetMap = allMaps.find((map) => map.uuid === targetMapUuid);

  if (!targetMap) {
    console.warn(`Map not found for UUID: ${targetMapUuid}`);
    return null;
  }

  if (!targetMap.owner?.name || !targetMap.shortId) {
    console.warn(`Missing owner name or shortId for map: ${targetMapUuid}`, {
      ownerName: targetMap.owner?.name,
      shortId: targetMap.shortId,
    });
    return null;
  }

  return `/${targetMap.owner.name}/maps/${targetMap.shortId}?view=treeview`;
}
